import React from 'react'

export default function ShowFolio( { datos } ) {

    function onCargaImagen() {
        console.log("Cargando Imagen")
    }

  return (
    <div className='pt-2'>
        <div className='row'style={{height:'30px'}}>
            <div className='col-3'>
                <p>Celular</p>
            </div>
            <div className='col-9'>
<               p>{datos.celular}</p>
            </div>
        </div>

        <div className='row' style={{height:'30px'}}>
            <div className='col-3'>
                <p>Cliente</p>
            </div>
            <div className='col-9'>
<               p style={{fontSize:'12px'}}>{datos.cliente}</p>
            </div>
        </div>


        <div className='row' style={{height:'30px'}}>
            <div className='col-3'>
                <p>FV</p>
            </div>
            <div className='col-9'>
<               p>{datos.fv}</p>
            </div>

        </div>

        <div className='row' style={{height:'30px'}}>

            <div className='col-3'>
                <p>Estatus</p>
            </div>
            <div className='col-9'>
<               p>{datos.estatus}</p>
            </div>
        </div>

        <div className='row' style={{height:'30px'}}>

            <div className='col-3'>
                <p>FolioSisact</p>
            </div>
            <div className='col-9'>
                <p>{datos.foliosisact}</p>
            </div>
        </div>


        <div className='row' style={{height:'30px'}}>

            <div className='col-3'>
                <p>Fecha</p>
            </div>
            <div className='col-9'>
                <p>{datos.fecha}</p>
            </div>
        </div>

        <div className='row'>
            <div className='col-6 pt-2'>
                <button type="button"  className="btn btn-primary mt-3 button-3" onClick={onCargaImagen} >Cargar Imagenes</button>
                
            </div>

        </div>



    </div>
  )
}
